import { useCallback, useEffect, useState } from 'react'

import {
  UseVideoMetadataInputProps,
  UseVideoMetadataOutputProps,
  VideoMetadataPlaylist,
  VideoMetadataResponse,
} from './types'
import { fetchVideoMetadata, getMotionThumbnailSource } from './utils'

const useVideoMetadataFetching = ({
  jwVideoId,
}: UseVideoMetadataInputProps): UseVideoMetadataOutputProps => {
  const [videoMetadataPlaylist, setVideoMetadata] = useState<
    VideoMetadataPlaylist | undefined
  >()

  const getVideoMetadata = useCallback(() => {
    fetchVideoMetadata(jwVideoId).then((res) => {
      const response = res as VideoMetadataResponse
      setVideoMetadata(response?.playlist?.[0])
    })
  }, [jwVideoId])

  useEffect(() => {
    if (jwVideoId && !videoMetadataPlaylist) {
      getVideoMetadata()
    }
  }, [videoMetadataPlaylist, getVideoMetadata, jwVideoId])

  return {
    fetchedPosterUrl: videoMetadataPlaylist?.image,
    fetchedSourceUrl: videoMetadataPlaylist?.sources[0]?.file,
    fetchedMotionThumbnailUrl: getMotionThumbnailSource(
      videoMetadataPlaylist?.images,
    ),
  }
}

export default useVideoMetadataFetching
